/* modules imports */
import styled, { css, keyframes } from "styled-components";

/* project files imports */
import Button from "components/Button";
import { devices } from "constants/style";
import { DemoStep } from "./constants";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px 0;
  box-sizing: border-box;
`;

const fadeOut = keyframes`
  100% { opacity: 0; }
`;

const fadeBackIn = keyframes`
  0% { opacity: 0; }
`;

type WrapperProps = {
  demoStep: DemoStep;
};

/* centered when the screen is tall enough, starts at the top otherwise */
export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 30px;
  margin: auto 0;

  /*
   * fade out then back in, to hide the logo moving when the demo
   * is replaced by the login buttons; the delay leaves time to see
   * the last choice
   */
  ${({ demoStep }) => demoStep === DemoStep.LEAVING && css`
    animation: ${fadeOut} .3s forwards;
    animation-delay: .4s;
  `}

  ${({ demoStep }) => demoStep === DemoStep.DONE && css`
    animation: ${fadeBackIn} .3s;
  `}
`;

export const Image = styled.img`
  width: 275px;

  @media ${devices.sm} { width: 300px; }
  @media ${devices.lg} { width: 350px; }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 10px;
`;

export const fadeIn = keyframes`
  100% { opacity: 1; }
`;

export const Text = styled.span`
  margin-bottom: 10px;
  font-size: 16px;
  text-align: center;
  opacity: 0;
  animation: ${fadeIn} .3s forwards;

  @media ${devices.sm} { font-size: 18px; }
  @media ${devices.lg} { font-size: 20px; }
`;

type StyledButtonProps = {
  index: number;
};

export const StyledButton = styled(Button)<StyledButtonProps>`
  opacity: 0;
  animation: ${fadeIn} .3s forwards;
  animation-delay: ${({ index }) => index * .15}s;
`;

export const AboutLink = styled.span`
  display: flex;
  align-items: center;
  column-gap: 6px;
  margin-top: 10px;
  color: var(--color-red);
  font-size: 15px;
  cursor: pointer;
  user-select: none;
  opacity: 0;
  animation: ${fadeIn} .3s forwards;
  animation-delay: .45s; /* right after the 3 buttons */

  @media ${devices.sm} { font-size: 16px; }
  @media ${devices.lg} { font-size: 17px; }

  &:hover {
    text-decoration: underline;
  }
`;

export const AboutIcon = styled.img`
  width: 15px;
  height: 15px;
`;

export const BoldText = styled.span`
  font-family: var(--font-content-bold);
`;
